export const TYPE_PLAYER_MOVE = 'player_moved';

class PlayerMove {
    
    constructor(data) {
        this.data = data
    }
    
    handle(game) {
        const data = this.data;
        game.getPlayers().getById(data.id)
            .getPosition()
            .setX(data.x)
            .setY(data.y)
    }
    
}

export default PlayerMove
